var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pay"}},[_c('van-button',{attrs:{"plain":"","type":"primary"},on:{"click":_vm.doPay}},[_vm._v("支付")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }